import { useRouteModalHistory } from '@/router'
import { Button } from '@seiue/ui'
import { $t } from 'packages/locale'
import { FC } from 'react'
import { useTheme } from 'styled-components'

export const AcademicAffairsCard: FC = () => {
  const history = useRouteModalHistory()
  const theme = useTheme()

  return (
    <>
      <Button
        icon="BarChartSolid"
        iconRight="GreaterThan"
        onClick={() => {
          history.push('GatewayGpaDetails')
        }}
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          color: theme.text._1,
          marginTop: -12,
        }}
      >
        {$t('查看学生选科绩点详情')}
      </Button>
      <Button
        icon="BarChartSolid"
        iconRight="GreaterThan"
        onClick={() => {
          history.push('GatewayNineGpaDetails')
        }}
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          color: theme.text._1,
          marginTop: -12,
        }}
      >
        {$t('查看学生九科绩点详情')}
      </Button>
      <Button
        icon="BarChartSolid"
        iconRight="GreaterThan"
        onClick={() => {
          history.push('GatewayZeroCreditDetails')
        }}
        style={{
          backgroundColor: '#fff',
          borderRadius: '16px',
          color: theme.text._1,
          marginTop: -12,
        }}
      >
        {$t('查看军训无学分学生详情')}
      </Button>
    </>
  )
}
